var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem-container"},[_c('div',{staticClass:"problem-common-wrapper search-wrapper"},[_c('div',{staticStyle:{"padding":"0 15px 10px"}},[_c('h3',[_vm._v(_vm._s(_vm.problem.problemName))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.problem.problemAnswer)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }